import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["featureGroup", "featureName", "featureNameForDescription", "creditsUsed", "totalCredits", "resetDate", "lastBannerSeen", "lastBannerLimitSeen", "usageTracker", "isAdmin", "billingType"];
import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Spacer } from 'foundations-components/components/Spacer';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { HubUserAttributesClient } from 'frontend-preferences-client';
import { logError } from '../../../../utils/logError';
import { CreditsCta } from '../CreditsCta';
import { STATUS_BANNER_VARIANTS } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeatureUsageStatusBanner = _ref => {
  let {
      featureGroup,
      featureName,
      featureNameForDescription,
      creditsUsed,
      totalCredits,
      resetDate,
      lastBannerSeen,
      lastBannerLimitSeen,
      usageTracker,
      isAdmin,
      billingType
    } = _ref,
    alertProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  let title;
  let description;
  let alertType;
  let cta = null;
  const hubUserAttributesClient = HubUserAttributesClient.forCaller('hs-usage-based-billing-fe');
  const feature = featureName || (featureGroup ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: `global.credits.featureGroups.${featureGroup}`
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "creditsAwareness.creditStatusBanner.thisFeature"
  }));

  // use featureNameForDescription if provided, otherwise use featureName
  const featureForDescription = featureNameForDescription || feature;
  if (creditsUsed >= totalCredits) {
    title = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "creditsAwareness.creditStatusBanner.featureUsage.usagePaused.title",
      options: {
        feature
      }
    });
    const descriptionMessage = isAdmin ? 'creditsAwareness.creditStatusBanner.featureUsage.usagePaused.adminDescription' : 'creditsAwareness.creditStatusBanner.featureUsage.usagePaused.description';
    description = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: descriptionMessage,
      options: {
        feature: featureForDescription,
        resetDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: I18n.moment.portalTz(resetDate),
          format: "MMM DD, YYYY"
        })
      }
    });
    alertType = 'danger';
    cta = /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(Spacer, {
        space: "100"
      }), /*#__PURE__*/_jsx(CreditsCta, {
        size: "xs",
        isAdmin: isAdmin,
        billingType: billingType,
        usageTracker: usageTracker
      })]
    });
    hubUserAttributesClient.write('UBB:LastCreditStatusBannerSeen', STATUS_BANNER_VARIANTS.FEATURE_PAUSED).catch(() => {
      logError({
        error: new Error('UBB-components-lib: Failed to write credit status banner seen')
      });
    });
    hubUserAttributesClient.write('UBB:LastCreditStatusBannerLimitSeen', totalCredits.toString()).catch(() => {
      logError({
        error: new Error('UBB-components-lib: Failed to write credit status banner limit seen')
      });
    });
  } else if (lastBannerSeen === STATUS_BANNER_VARIANTS.FEATURE_PAUSED) {
    if (isAdmin) {
      cta = /*#__PURE__*/_jsxs(View, {
        children: [/*#__PURE__*/_jsx(Spacer, {
          space: "100"
        }), /*#__PURE__*/_jsx(CreditsCta, {
          size: "xs",
          isAdmin: isAdmin,
          billingType: billingType,
          usageTracker: usageTracker,
          userRecentlyPurchasedCredits: totalCredits > lastBannerLimitSeen
        })]
      });
    }
    if (totalCredits <= lastBannerLimitSeen) {
      description = /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "creditsAwareness.creditStatusBanner.featureUsage.usageRestored.description.reset",
        options: {
          feature: featureForDescription
        }
      });
      hubUserAttributesClient.write('UBB:LastCreditStatusBannerSeen', STATUS_BANNER_VARIANTS.CREDITS_RESET).catch(() => {
        logError({
          error: new Error('UBB-components-lib: Failed to write credit status banner seen')
        });
      });
    } else {
      description = /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "creditsAwareness.creditStatusBanner.featureUsage.usageRestored.description.addedCredits",
        options: {
          feature: featureForDescription
        }
      });
      hubUserAttributesClient.write('UBB:LastCreditStatusBannerSeen', STATUS_BANNER_VARIANTS.CREDITS_ADDED).catch(() => {
        logError({
          error: new Error('UBB-components-lib: Failed to write credit status banner seen')
        });
      });
    }
    title = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "creditsAwareness.creditStatusBanner.featureUsage.usageRestored.title",
      options: {
        feature
      }
    });
    alertType = 'info';
  } else {
    return null;
  }
  return /*#__PURE__*/_jsxs(Alert, Object.assign({
    type: alertType,
    "data-test-id": "feature-usage-status-banner",
    closeable: true
  }, alertProps, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h5",
      children: title
    }), /*#__PURE__*/_jsx(Spacer, {
      space: "100"
    }), /*#__PURE__*/_jsx(Text, {
      children: description
    }), cta]
  }));
};